<template>
  <div>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="关于我们" name="1">
        商城介绍<br/><br/>
        海尔积分商城，是为了回馈海尔用户的支持，提高海尔的服务质量，面向所有海尔会员的唯一权益领取-兑换-服务的全流程数字化服务平台，可兑换商品涵盖：海尔小家电，高端餐厨用具，电子数码，家居日用，母婴，海尔文创，家庭医疗等10大类，60余小类；您可以足不出户，一站尽享礼品兑换-送货到家-完善售后的服务体验；海尔智家积分商将不断的完善和丰富兑换奖励品的方式，优化兑换体验，丰富兑换内容，让海尔积分商城更好的服务于所有海尔用户。
      </van-collapse-item>
      <van-collapse-item title="积分查询" name="2">
        <p>
          查询路径及方式<br/><br/>
          您可通过登录海尔积分商城网址、海尔智家APP、海尔智家公众号、或拨打4006999999客服热线等方式查询账户内可用积分余额。
        </p>
      </van-collapse-item>
      <van-collapse-item title="积分使用及有效期" name="3">
        1.海尔积分自领取生效日起1年内有效。例：2020年5月1日领取1000积分，该1000积分将于2021年4月30日过期。<br/>
2.在进行兑换时：按积分获取时间先后顺序扣减，请留意积分有效期，以免带来不便。<br/>
3.您可通过”登录海尔智家APP-我的-我的积分“路径，进入账户积分明细，查询积分使用记录。
      </van-collapse-item>
      <van-collapse-item title="积分获取方式" name="4">
        一、积分介绍 <br/><br/>
        海尔积分是专为海尔用户管理和使用积分的虚拟货币，海尔会员可以使用积分兑换各类实物，虚拟礼品或海尔产品的清洁保养、延保服务以及其他增值服务。<br/><br/>
        二、积分获取<br/><br/>
        1.【购机积分】会员购买指定海尔/卡萨帝品牌产品，产生消费行为，根据活动规则获取相应积分。<br/>
2.【互动积分】：<br/>
(1)参与海尔智家APP“每日签到”领取积分，参与热门活动获取更多积分；<br/>
(2)登录“海尔社区”打卡、发帖、社区互动领取积分；<br/>
(3)卡萨帝品牌“晒单追评“等会员互动积分奖励；<br/>
后续更多积分获取福利，敬请期待！
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { sysNotice } from "@/api/api";
export default {
  data() {
    return {
      list: [],
      activeNames: [],
    };
  },
  methods: {
    
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.text {
  padding-top: 50px;
}
/deep/.blue {
  color: #2283e2 !important;
}
.contai {
  background: #fff;
  // border: 1px solid #2283e2;
  padding: 20px;
}

.header {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #2283e2;
}

.paging {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.title {
  font-size: 25px;
  cursor: pointer;
}

.title:hover {
  color: #2283e2;
}
</style>
